import axios from "./AxiosService";
import { encrypt } from "../../src/helpers/ICryptoHelper";


export function getClaimMembers(membershipNumber) {
  return axios
    .get("claims", {
      params: { membershipNumber }
    })
    .then(response => {
      return response;
    })
    .catch(error => {
      return error;
    });
}
export function getClaimSummaryForMember(membershipNumber, securityId) {
  return axios
    .get("claims", {
      avoidLoadingFeature: true,
      params: { membershipNumber, securityId }
    })
    .then(response => {
      return response;
    })
    .catch(error => {
      return error;
    });
}

export function getClaimDetailsForClaim(claimReference) {
  // Encrypt claimReference before sending to prevent IDOR attack
  const sKey = process.env.REACT_APP_BankEncryptionKey_API_KEY;
  const enClaimReference = encrypt(claimReference, sKey);
  return axios
    .get("claimdetails", {
      params: { claimReference : enClaimReference}
    })
    .then(response => {
      return response;
    })
    .catch(error => {
      return error;
    });
}

export function getPaymentDetailsForClaimAndInvoice(
  claimReference,
  partialInvoiceReference,
  membershipNumber,
  securityId
) {
  // Encrypt claimReference before sending to prevent IDOR attack
  const sKey = process.env.REACT_APP_BankEncryptionKey_API_KEY;
  const enClaimReference = encrypt(claimReference, sKey);
  return axios
    .get("paymentdetails", {
      params: {
        claimReference: enClaimReference,
        partialInvoiceReference,
        membershipNumber,
        securityId
      }
    })
    .then(response => {
      return response;
    })
    .catch(error => {
      return error;
    });
}

export function getPaymentDetailsForNotification(
  invoiceReference,
  membershipNumber,
  notificationSecurityId
) {
  // Encrypt invoiceReference before sending to prevent IDOR attack
  const sKey = process.env.REACT_APP_BankEncryptionKey_API_KEY;
  const eninvoiceReference = encrypt(invoiceReference, sKey);
  return axios
    .get("paymentdetails", {
      params: {
        invoiceReference: eninvoiceReference,
        membershipNumber,
        notificationSecurityId
      }
    })
    .then(response => {
      return response;
    })
    .catch(error => {
      return error;
    });
}
export function getMemberDetailsService(policyNumber,ssoId){
  return axios
    .get("claimdetails", 
      {
        params:{
          policyNumber,
          ssoId
        }
      }
    )
    .then(response => {
      return response;
    })
    .catch(error => {
      return error;
    });
}
export  function getClaimConditionForMember(ssoId,policyNumber,memberplanId){
  return axios
    .get("claimdetails", {
      params:{
        ssoId,
        policyNumber,
        memberplanId
      }
    }
    )
    .then(response => {
      return response;
    })
    .catch(error => {
      return error;
    });
}
